import { mergeStyles } from '@cian/utils';
import MaskedInput from 'react-text-mask';
// tslint:disable-next-line: match-default-export-name
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import * as React from 'react';
import * as R from 'ramda';

import * as styles from './NumberInput.css';

export interface INumberInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  error?: boolean;
  suffix?: React.ReactNode;
  integerLimit: number;
  onValueChange?(value: number | undefined): void;
}

const NUMBER_MASK_OPTIONS = {
  prefix: '',
  thousandsSeparatorSymbol: ' ',
};

export class NumberInput extends React.Component<INumberInputProps> {
  public static defaultProps: Partial<INumberInputProps> = {
    integerLimit: 12,
  };

  public render() {
    const { suffix } = this.props;

    if (R.isNil(suffix)) {
      return this.renderInput();
    }

    return (
      <span {...mergeStyles(
        styles['wrapper'],
        !R.isNil(suffix) && this.props.className,
        !R.isNil(suffix) && this.props.style,
      )}>
        {this.renderInput()}
        {!R.isNil(suffix) && <span className={styles['suffix']}>{suffix}</span>}
      </span>
    );
  }

  private renderInput = () => {
    const { error, suffix, integerLimit, onValueChange, ...sharedProps } = this.props;

    return (
      <MaskedInput
        {...sharedProps}
        type="text"
        {...mergeStyles(
          styles['input'],
          error && styles['input--error'],
          !R.isNil(suffix) && styles['input--suffix'],
          R.isNil(suffix) && this.props.className,
          R.isNil(suffix) && this.props.style,
        )}
        onChange={this.handleChange}
        mask={createNumberMask({
          ...NUMBER_MASK_OPTIONS,
          integerLimit,
        })}
      />
    );
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    if (this.props.onValueChange) {
      const value = event.currentTarget.value.replace(/\s+/gi, '');
      this.props.onValueChange(!!value ? Number(value) : undefined);
    }
  }
}
